import React from 'react';
import Reactable from 'reactable';
import PropTypes from 'prop-types';
import TableCell from '../../../../common/TableCell';
import * as shapes from '../shapes';

const { Tfoot } = Reactable;

const totalRow = (total, columns) => {
  if (!total) {
    return null;
  }
  const totalColumns = {
    ...total,
    Name: 'Total',
    'Barber Commission': '-',
  };

  return (
    <tr>
      {columns.map(column => (
        <td className="u-pv- u-type--bold" key={column} data-automation-id={`text:footer:${column}`}>
          <TableCell column={column}>{totalColumns[column]}</TableCell>
        </td>
      ))}
    </tr>
  );
};

const unassignedRow = (unassigned, columns) => {
  if (!unassigned) {
    return null;
  }

  const unassignedColumns = {
    ...unassigned,
    Name: 'Unassigned sales',
    'Barber Commission': '-',
  };
  return (
    <tr>
      {columns.map(column => (
        <td className="u-pv- u-type--bold" key={column}>
          <TableCell column={column}>{unassignedColumns[column]}</TableCell>
        </td>
      ))}
    </tr>
  );
};

const Item = ({ columns, unassigned, total }) => {
  return (
    <Tfoot>
      {unassignedRow(unassigned, columns)}
      {totalRow(total, columns)}
    </Tfoot>
  );
};

Item.propTypes = {
  total: shapes.commissionSplitItem.isRequired,
  unassigned: shapes.commissionSplitItem.isRequired,
  columns: shapes.columns.isRequired,
};

export default Item;
